import { RankedTester, and, isControl, optionIs, rankWith } from "@jsonforms/core";

export const EventFinancialActionTester: RankedTester = rankWith(
  20,
  and(isControl, optionIs("EventFinancialAction", true))
);

export default EventFinancialActionTester;
